var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V10.5C0.5 11.6046 1.39543 12.5 2.5 12.5H10.5C11.6046 12.5 12.5 11.6046 12.5 10.5V4.32843C12.5 3.79799 12.2893 3.28929 11.9142 2.91421L10.0858 1.08579C9.71071 0.710714 9.20201 0.5 8.67157 0.5H8M3.5 0.5V1.5C3.5 2.60457 4.39543 3.5 5.5 3.5H6C7.10457 3.5 8 2.60457 8 1.5V0.5M3.5 0.5H8M6.5 6.5C5.99975 6.5 5 6.8 5 8C5 9.2 5.99975 9.5 6.5 9.5C7.00025 9.5 8 9.2 8 8C8 6.8 7.00025 6.5 6.5 6.5Z",
    stroke: "#FFF057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.f2afebbaa70b57732bab3dcaf8634794.svg";
export { ForwardRef as ReactComponent };